export default __webpack_public_path__ + "static/media/sh_10.70ab1201.png";